<template>
  <div class="authority-scheme-mgmt">
    <div class="main-title">
      <p>权限方案管理</p>
    </div>
    <div class="main-body">
      <div class="list">
        <span>方案编号：</span>
        <el-input class="list-input" v-model="schemeNo" clearable></el-input>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
        <div class="blue-btn ml10" @click="onAddBtnClick">新增</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th width="150px">方案编号</th>
          <th width="150px">创建时间</th>
          <th width="150px">方案名称</th>
          <th class="text-left">权限功能</th>
          <th width="150px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList">
          <td>{{ item.schemeNo }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.schemeName }}</td>
          <td class="text-left">{{ item.schemeContent }}</td>
          <td>
            <div class="text-btn" @click="onEditBtnClick(item)">编辑</div>
            <div class="text-btn" @click="onDeleteBtnClick(item)">删除</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="5">暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <!--<div class="page-count">第{{pageIndex}}页，当前页{{dataList.length}}条</div>-->
        <div class="pre-btn" disabled :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'authoritySchemeMgmt',
  data() {
    return {
      schemeNo: '',
      dataList: [],
      beginIndex: 0,
      pageSize: 10,
      preBtnDisabled: true,
      nextBtnDisabled: true,
    }
  },
  computed: {
    pageIndex() {
      return Math.floor(this.beginIndex / this.pageSize) + 1;
    },
  },
  mounted() {
    this.queryAuthorityScheme();
  },
  methods: {
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.queryAuthorityScheme();
    },
    queryAuthorityScheme() {
      let self = this;
      let params = {
        schemeNo: this.schemeNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
      };
      this.$http.post('/managementPlatform/authority/queryAuthorityScheme', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onAddBtnClick() {
      this.$router.push('/managePage/authoritySchemeMgmtAddView');
    },
    onDeleteBtnClick(item) {
      var self = this;
      this.$confirm('是否确定删除?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.deleteItem(item);
      }).catch(action => {
      });
    },
    deleteItem(item) {
      let self = this;
      let params = {
        schemeNo: item.schemeNo,
      };
      this.$http.post('/managementPlatform/authority/deleteAuthorityScheme', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "操作失败!",
            center: true
          });
          return;
        }
        self.queryAuthorityScheme();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onEditBtnClick(item) {
      this.$router.push('/managePage/authoritySchemeMgmtEditView?schemeNo=' + item.schemeNo + '&schemeName=' + item.schemeName)
    },
    onPreBtnClick: function () {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.queryAuthorityScheme();
    },
    onNextBtnClick: function () {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.queryAuthorityScheme();
    },
    resetPreAndNextBtn: function (length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;

  .name-label {
    float: left;
  }

  .value-label {
    display: inline-block;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 190px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/unitMgmt/authoritySchemeMgmt.vue